import {parameterize} from './utils'

/**
 * Returns a relative URL to the GitHub Models catalog, optionally filtered to show specific results.
 */
export function modelsCatalogPath({category, task}: {category?: string | null; task?: string | null} = {}) {
  if (!category && !task) return '/marketplace/models/catalog'

  const params = new URLSearchParams()
  params.append('type', 'models')
  if (category) params.append('category', category)
  if (task) params.append('task', parameterize(task))
  return `/marketplace?${params.toString()}`
}
